// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.FilterItem.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Filter Item component
 */

import classnames from 'classnames';
import { any, noop } from 'lodash/fp';
import { ACCESS_RIGHT } from 'logic/data/Izenda.AuthorizationConstants';
import CONSTANTS from 'logic/data/Izenda.FilterDetailsConfigConstants';
import OperatorGroup from 'modules/ReportDesigner/Fields/Filter/Izenda.OperatorGroup';
import OperatorValue from 'modules/ReportDesigner/Fields/Filter/Izenda.OperatorValue';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import OverflowText from 'share/components/controls/Izenda.OverflowText';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import connect from 'share/enhancers/Izenda.Connect';
import 'share/utils/Izenda.StringUtilities';

@connect()
export default class FilterItem extends Component {
  static propTypes = {
    configField: PropTypes.object.isRequired
  };

  /**
   * Handle change of operator value.
   * @param {string} value
   */
  onChangeOperatorValue = (value: string): void => {
    const { props } = this;
    const configField = props.configField || {};
    configField.setFilterValue && configField.setFilterValue(value);
    props.updateCascadingValue && props.updateCascadingValue();
  };

  /**
   * Render operator value component.
   */
  renderOperatorValue() {
    const {
      props,
      props: { configField = {}, viewMode, index, accessPriority, isLazyLoading }
    } = this;
    const filterInfo = configField.filterInfo;
    const filterSource = configField.operatorSourceValue;

    if (this.doesRenderOperator(filterInfo.group.name, filterInfo.operator.name)) return null;

    return (
      <OperatorValue
        filterSource={filterSource}
        filterInfo={filterInfo}
        configField={configField}
        operatorGroup={configField}
        onChange={this.onChangeOperatorValue}
        index={index}
        viewMode={viewMode}
        disabled={accessPriority === ACCESS_RIGHT.Locked}
        store={props.fieldStore}
        isLazyLoading={isLazyLoading}
      />
    );
  }

  /**
   * Render operator component.
   */
  renderOperator() {
    const {
      props,
      props: { isLazyLoading }
    } = this;
    const configField = props.configField || {};
    const filterInfo = configField.filterInfo;

    if (!this.doesRenderOperator(filterInfo.group.name, filterInfo.operator.name)) return null;

    return (
      <OperatorGroup
        notInReportDesignerMode
        configField={configField}
        updateSourceValue={noop}
        isLazyLoading={isLazyLoading}
      />
    );
  }

  /**
   * Check need to render operator.
   * @param {String} operatorGroupName
   * @param {String} operatorName
   */
  doesRenderOperator(operatorGroupName: string, operatorName: string): boolean {
    return (
      operatorGroupName === CONSTANTS.OPERATOR_GROUP_KEYS.BOOLEAN ||
      any(value => operatorName === value, CONSTANTS.OPERATOR_KEYS)
    );
  }

  render() {
    const props = this.props;
    const configField = props.configField || {};
    const fieldDetails = configField.fieldDetails || {};
    const filterInfo = configField.filterInfo;
    const isRequiredFilter = fieldDetails.required;

    const label = fieldDetails.alias;
    const operator =
      filterInfo.operator.name === CONSTANTS.OPERATOR_GROUP.UNKNOWN
        ? CONSTANTS.DEFAUFT_OPERATOR_LABEL
        : filterInfo.operator.name;

    const mode =
      CONSTANTS.SHOW_MODE_OPERATOR.indexOf(filterInfo.operator.key) > -1
        ? configField.fieldDetails.operatorSetting === CONSTANTS.SELECT_SETTINGS.MULTIPLE
          ? ` - ${CONSTANTS.SELECT_TEXT.MULTIPLE}`
          : ` - ${CONSTANTS.SELECT_TEXT.SINGLE}`
        : '';
    const defaultToolTip = `${label} - ${operator}${mode}`;
    const tooltipOperator = fieldDetails.commonFilterRequired
      ? `${defaultToolTip} \n ${props.localization.getText('DASHBOARD_TOOLTIP_REQUIRED_FILTER')}`
      : defaultToolTip;

    const filterTextclassnames = classnames('normal', { 'required-before': isRequiredFilter });

    return (
      <GridLayout.Col cols='3' xs='12'>
        <div className='report-filter-item'>
          <div className='filter-item-label form-group u_noMarginAll'>
            <div className='filter-label'>
              <OverflowText tooltip={tooltipOperator} className={filterTextclassnames}>
                <span>{label} </span>
                <span className='operator'>{String.format(' - {0}{1}', operator, mode)}</span>
              </OverflowText>
            </div>
          </div>

          <div className='filter-item-value form-group u_paddingAll u_borderAll'>
            <ScrollBox>
              {this.renderOperator()}
              {this.renderOperatorValue()}
            </ScrollBox>
          </div>
        </div>
      </GridLayout.Col>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Reports/FilterProperty/Izenda.FilterItem.js